// Связка текста лекции с терминалом лабораторного окружения: команды из блоков кода можно
// вставить в открытый терминал одним нажатием (на телефоне набирать их пальцами — худшая часть работы).

export const LAB_INSERT_EVENT = 'lab-terminal-insert';

// Блоки кода с этими языками считаем командами оболочки; конфиги (```text, ```ini) и вывод команд — нет.
const COMMAND_LANGUAGES = ['bash', 'sh', 'shell', 'console', 'zsh'];

export const isCommandLanguage = (className = '') =>
    COMMAND_LANGUAGES.some((lang) => className.split(/\s+/).includes(`language-${lang}`));

// Вставляет текст в открытый лабораторный терминал (без нажатия Enter). false — открытого терминала нет.
export const insertIntoLabTerminal = (text) => {
    const detail = {text, handled: false};
    window.dispatchEvent(new CustomEvent(LAB_INSERT_EVENT, {detail}));
    return detail.handled;
};

// Блоки команд из markdown: ```bash ... ``` и ~~~bash ... ~~~. Приглашение «$ » в начале строк убираем.
export const extractCommandBlocks = (markdown) => {
    if (!markdown) return [];
    const blocks = [];
    const regex = /^(```|~~~)[ \t]*(bash|sh|shell|console|zsh)[ \t]*\r?\n([\s\S]*?)\r?\n\1[ \t]*$/gm;
    let match;
    while ((match = regex.exec(markdown)) !== null) {
        const text = match[3].split('\n').map((line) => line.replace(/^\$ /, '')).join('\n').trim();
        if (text) blocks.push(text);
    }
    return blocks;
};

// Открыт ли сейчас видимый лабораторный терминал — по нему блоки кода в тексте показывают кнопку «в терминал».
export const LAB_STATE_EVENT = 'lab-terminal-state';

export const setLabTerminalOpen = (open) => {
    document.body.dataset.labTerminal = open ? '1' : '0';
    window.dispatchEvent(new Event(LAB_STATE_EVENT));
};

export const isLabTerminalOpen = () => document.body.dataset.labTerminal === '1';
